import $ from 'jquery';
import Swiper, { Pagination } from 'swiper';
//import vars from '!!jdi-sass-vars-to-js-loader!../../../sass/template-parts/blocks/_testimonials-slider.scss';

function initTestimonialsSlider() {
  $(function () {
    if ($('.slider-block').length <= 0) {
      return;
    }

    //customizeSliderStyles();
    initSwiperJS();
  });
}

function initSwiperJS() {
  $('.testimonials-slider').each(function(){
    let slider = $(this).find('.slider-block');
    let pagination = $(this).find('.swiper-pagination');
    
    let swiperTouchStartX;
  
    let swiper = new Swiper(slider.get(0), {
      modules: [Pagination],
      slidesPerView: 1,
      spaceBetween: 200,
      loop: true,
      pagination: {
        el: pagination.get(0),
        clickable: true
      },
    });
  });
}

export { initTestimonialsSlider };
